var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"warper"}},[_c('div',{attrs:{"id":"app-contain"}},[_c('router-view')],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }